import { getActionTypes } from './get-actions';

export const getReducer = (actionPrefix) => (action) => ({
  [getActionTypes(actionPrefix).AUDIO_STARTED]: () => ({
    started: true,
  }),
  [getActionTypes(actionPrefix).AUDIO_ERROR]: () => ({
    error: true,
  }),
  [getActionTypes(actionPrefix).AUDIO_COMPLETED]: () => ({
    completed: true,
  }),
  [getActionTypes(actionPrefix).AUDIO_PAUSED]: () => ({
    paused: action.payload.paused,
  }),
  [getActionTypes(actionPrefix).AUDIO_DURATION]: () => ({
    paused: action.payload.duration,
  }),
  [getActionTypes(actionPrefix).AUDIO_PERCENTAGE]: () => ({
    paused: action.payload.percentage,
  }),
});
